import { createContext } from 'react';
export interface BookingSlotsContextType {
	setCurrentActive: (current: string) => void;
	currentActive: string;
}

export const BookingSlotsContext = createContext<
	BookingSlotsContextType | undefined
>(undefined);
